import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loader from 'src/components/common/Loader';

import { message } from 'src/Library/AntdLibComponents';
import { useGenericState } from 'src/Library/UseGenericState';
import { fetchSharedData } from './SharedPage.actions';
import { DISCOVER_RATES } from './constants';
import NotFound404 from 'src/components/common/NotFound404';
import DiscoverRates from './Modules/DiscoverRates';

interface SharedState {
  sharedData: {
    moduleType: string;
    attachmentData: any;
  } | null;
  loader: boolean;
}

const SharedPage = (): ReactElement => {
  const { sharingId } = useParams();
  const [state, setState] = useGenericState<SharedState>({
    sharedData: null,
    loader: false,
  });

  useEffect(() => {
    const getData = async () => {
      setState({ loader: true });
      const response: any = await fetchSharedData(sharingId);
      if (response.isSuccess) {
        setState({ sharedData: response.data, loader: false });
      } else {
        message.error(response.errorMessage);
        setState({ loader: false });
      }
    };
    getData();
  }, []);

  const renderPage = (): ReactElement => {
    const { sharedData } = state;

    switch (sharedData?.moduleType) {
      case DISCOVER_RATES:
        return <DiscoverRates data={sharedData?.attachmentData} />;
      default:
        return <NotFound404 />;
    }
  };

  return <div>{state.loader ? <Loader /> : renderPage()}</div>;
};

export default SharedPage;
